module.exports = __webpack_public_path__ + "assets/img/Compose_Video.0dbacfff.svg";